import { type Enum } from '../../utils/enums'

export const ImprovedImportTypes = {
  LOCATION: 'LOCATION',
  SHIPPING_ADDRESS: 'SHIPPING_ADDRESS',
  DEPARTMENT: 'DEPARTMENT',
} as const

export type ImprovedImportType = Enum<typeof ImprovedImportTypes>
